export default __webpack_public_path__ + "static/media/ring_outside.aa4bd9a0.svg";